import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-pagination-row',
  templateUrl: './pagination-row.component.html',
  styleUrls: ['./pagination-row.component.css']
})
export class PaginationRowComponent {
  @Input() pageSize: number;
  @Input() pageNum: number;
  @Input() reloadSubject: Subject<void>;
  @Input() lastPageNum: number;

  @Output() pageNumChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  constructor() {}
}
